import { render, staticRenderFns } from "./ReportingComparison.vue?vue&type=template&id=1c46a728&scoped=true&"
import script from "./ReportingComparison.vue?vue&type=script&lang=js&"
export * from "./ReportingComparison.vue?vue&type=script&lang=js&"
import style0 from "./ReportingComparison.vue?vue&type=style&index=0&id=1c46a728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46a728",
  null
  
)

export default component.exports